import { useStoreMediaDevices } from '@/entities/media-devices'

import { getMicrophonePermissionErrorMessage } from '@/shared/composables/media-stream'

/**
 * Ensures mic permission without opening a second capture when already granted.
 * Previously every join could call getUserMedia here and again in openMedia (~300ms later).
 */
export const grantMicrophonePermission = async (): Promise<boolean> => {
  const store = useStoreMediaDevices()
  const granted = await store.probeMicrophoneAccess()

  if (!granted) {
    throw new Error(getMicrophonePermissionErrorMessage(store.microphoneAccessError))
  }

  return true
}
